import { Haptics, ImpactStyle } from '@capacitor/haptics'

/**
 * Trigger haptic feedback
 * @param {string} type - Type of haptic feedback: 'light', 'medium', 'heavy', 'success', 'warning', 'error'
 */
export async function triggerHaptic(type = 'light') {
  try {
    const styleMap = {
      light: ImpactStyle.Light,
      medium: ImpactStyle.Medium,
      heavy: ImpactStyle.Heavy
    }

    // Await so a rejected promise (e.g. "Browser does not support the vibrate
    // API" on browsers without navigator.vibrate) is caught here instead of
    // surfacing as an unhandled rejection that Sentry reports.
    if (styleMap[type]) {
      await Haptics.impact({ style: styleMap[type] })
    } else if (type === 'success') {
      await Haptics.notification({ type: 'SUCCESS' })
    } else if (type === 'warning') {
      await Haptics.notification({ type: 'WARNING' })
    } else if (type === 'error') {
      await Haptics.notification({ type: 'ERROR' })
    } else {
      // Default to light impact
      await Haptics.impact({ style: ImpactStyle.Light })
    }
  } catch (error) {
    // Silently fail if haptics are not available (e.g., in web browser)
    console.debug('Haptics not available:', error)
  }
}


